module.exports = __webpack_public_path__ + "static/media/Free_Events_mr.f6a69f80.jpg";